<template>
    <b-modal
        v-model="modal"
        :title="modalTitle"
        title-class="text-grey font-weight-600"
        body-class="px-3s pt-3s pb-4s"
        :dialog-class="[dialogWidth]"
        hide-footer
        centered
        @show="fetchData"
        @hidden="onHidden"
    >
        <b-overlay :show="loading" spinner-variant="maya-blue">
            <div v-if="notifyMode">
                <TwoFANotify
                    :enable-mode="enableMode"
                    class="mb-4"
                ></TwoFANotify>
                <b-button
                    type="submit"
                    block
                    variant="cinnabar"
                    size="lg"
                    class="text-semi-xl text-white font-weight-600 rounded-xxl"
                    @click="modal = false"
                >
                    {{ $t('button.close') }}
                </b-button>
            </div>
            <VerifyTwoFAForm
                v-else
                v-model="otpCode"
                :qr-code="qrCode"
                :enable-mode="enableMode"
                @success="onSuccess"
            ></VerifyTwoFAForm>
        </b-overlay>
    </b-modal>
</template>

<script>
import TwoFANotify from '@/components/auth/TwoFANotify/TwoFANotify';
import VerifyTwoFAForm from '@/components/auth/VerifyTwoFAForm/VerifyTwoFAForm';
import { TWO_FACTOR_STATUSES } from '@/constants/auth';
import errorMixin from '@/mixins/error';
import { enableTwoFA } from '@/services/auth.service';
import { mapState } from 'vuex';

export default {
    name: 'ModalVerifyTwoFA',
    components: { TwoFANotify, VerifyTwoFAForm },
    mixins: [errorMixin],
    props: {
        value: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    data() {
        return {
            qrCode: null,
            otpCode: '',
            loading: false,
            notifyMode: false,
        };
    },
    computed: {
        ...mapState('auth', ['user']),
        modal: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        modalTitle() {
            const disableText = !this.enableMode
                ? `${this.$t('button.disable')} `
                : '';
            return disableText + this.$t('auth.two_factor_authentication');
        },
        enableMode() {
            return [
                TWO_FACTOR_STATUSES.ENABLING.key,
                TWO_FACTOR_STATUSES.DISABLED.key,
            ].includes(this.user?.twoFactorStatus);
        },
        dialogWidth() {
            return this.notifyMode ? 'max-w-427-px' : 'max-w-640-px';
        },
    },
    methods: {
        fetchData() {
            if (this.enableMode) {
                this.loading = true;
                enableTwoFA()
                    .then(({ data }) => {
                        this.qrCode = data.otpAuthUrl;
                    })
                    .catch((e) => {
                        this.handleThrowError(e);
                    })
                    .then(() => {
                        this.loading = false;
                    });
            }
        },
        resetData() {
            this.qrCode = null;
            this.otpCode = '';
            this.notifyMode = false;
        },
        onHidden() {
            this.resetData();
            this.$store.dispatch('auth/fetchUser');
        },
        onSuccess() {
            this.notifyMode = true;
        },
    },
};
</script>

<style scoped></style>
